// Caixa de aviso dos modais e do card (info / warn / error), com ícone e
// texto — a cor nunca é o único sinal.
import React from "react";
import { makeStyles, alpha } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import WarningOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";

import { AEROS, stateText } from "../../styles/aerosTokens";

const TONS = {
  info: { color: AEROS.cyan, key: "info" },
  warn: { color: AEROS.warning, key: "warning" },
  error: { color: AEROS.error, key: "error" },
};

const useStyles = makeStyles((theme) => ({
  box: ({ tone }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    padding: "10px 14px",
    borderRadius: 12,
    fontSize: 12.5,
    lineHeight: 1.5,
    color: theme.palette.text.primary,
    backgroundColor: alpha(TONS[tone].color, 0.08),
    border: `1px solid ${alpha(TONS[tone].color, 0.3)}`,
    "& > .MuiSvgIcon-root": {
      fontSize: 17,
      marginTop: 1,
      flex: "none",
      color: stateText(theme, TONS[tone].color, TONS[tone].key),
    },
  }),
  text: { minWidth: 0, overflowWrap: "anywhere" },
}));

const Notice = ({ tone = "info", children, live = false }) => {
  const classes = useStyles({ tone });
  const Icon = tone === "info" ? InfoOutlinedIcon : WarningOutlinedIcon;
  return (
    <div
      className={classes.box}
      role={live ? "status" : undefined}
      aria-live={live ? "polite" : undefined}
    >
      <Icon aria-hidden="true" />
      <div className={classes.text}>{children}</div>
    </div>
  );
};

export default Notice;
